"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const lit_1 = require("lit");
const decorators_js_1 = require("@lit/reactive-element/decorators.js");
const style_map_js_1 = require("lit-html/directives/style-map.js");
class Tabs extends lit_1.LitElement {
    constructor() {
        super();
        this.activeTab = 0;
        this.tabPosition = "top";
        this.tabs = Array.from(this.querySelectorAll("[slot=tab]"));
        this.panels = Array.from(this.querySelectorAll("[slot=panel]"));
        this.selectTab(this.activeTab);
        console.dir(this.activeTab);
    }
    selectTab(tabIndex) {
        // remove selected attribute from all tabs
        this.tabs.forEach(tab => tab.removeAttribute("selected"));
        // remove selected attribute from all panels
        this.panels.forEach(panel => panel.removeAttribute("selected"));
        // check if tab exists at index tabIndex
        if (this.tabs[tabIndex]) {
            // set selected attribute on tab with index tabIndex
            this.tabs[tabIndex].setAttribute("selected", "");
            // set selected attribute on panel with index tabIndex
            this.panels[tabIndex].setAttribute("selected", "");
            return;
        }
        // if tab does not exist at index tabIndex, select first tab
        this.selectTab(0);
    }
    get classes() {
        return {};
    }
    get styles() {
        return {};
    }
    handleTabClick(e) {
        const index = this.tabs.indexOf(e.target);
        this.selectTab(index);
    }
    render() {
        return (0, lit_1.html) `
      <div class="tabs" style="${(0, style_map_js_1.styleMap)({})}">
        <nav>
          <slot
            name="tab"
            @click="${(e) => this.handleTabClick(e)}"
          ></slot>
        </nav>

        <div>
          <slot name="panel"></slot>
        </div>
      </div>
    `;
    }
}
Tabs.styles = [
    // language=css
    (0, lit_1.css) `
        .tabs {
            display: grid;
            grid-template-columns: 1fr;
        }
        
        nav {
            display: flex;
            flex-wrap: wrap;
        }

        ::slotted([slot="panel"]) {
            display: none;
        }

        ::slotted([slot="panel"][selected]) {
            display: block;
        }
    `
];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: "active-tab" })
], Tabs.prototype, "activeTab", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: "tab-position" })
], Tabs.prototype, "tabPosition", void 0);
exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map